import { AdaptStorage } from "./storage";

export const SessionStorage = new AdaptStorage("adaptSessionStorage", window.sessionStorage);
